import { useLocation } from "react-router-dom";

/**
 * Optional `location.state.patientBack` overrides the app bar back target:
 * `{ patientBack: { to: string, label?: string } }`.
 */
export function usePatientSubpageBack(defaults) {
  const { state } = useLocation();
  const explicit = state?.patientBack;
  if (explicit && typeof explicit.to === "string" && explicit.to.length > 0) {
    return {
      backTo: explicit.to,
      backLabel:
        typeof explicit.label === "string" && explicit.label.trim()
          ? explicit.label.trim()
          : "Back",
    };
  }
  return {
    backTo: defaults.to,
    backLabel: defaults.label,
  };
}
